// extracted by mini-css-extract-plugin
var _1 = "GroupView-module__aboveAllContainer--wkKMt";
var _2 = "GroupView-module__animateUploadProgressBarWidth--F9EtQ";
var _3 = "GroupView-module__animatedBackground--FkCec";
var _4 = "GroupView-module__controlsContainer--MUw_e";
var _5 = "GroupView-module__description--zGvEs";
var _6 = "GroupView-module__isCompactLayout--xkZtv";
var _7 = "GroupView-module__isEditing--uN5TZ";
var _8 = "GroupView-module__titleRow--_UsEX";
export { _1 as "aboveAllContainer", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "controlsContainer", _5 as "description", _6 as "isCompactLayout", _7 as "isEditing", _8 as "titleRow" }
